export const HYCOM_V02 = {
  title: {
    value: "HYCOM ESPC-D-V02",
  },
  paragraph: {
    value: `The data set from HYCOM (Hybrid Coordinate Ocean Model) include global-scale ocean model data. HYCOM is a consortium of multi-institutional effort sponsored by the National Ocean Partnership Program (NOPP), as part of the U. S. Global Ocean Data Assimilation Experiment (GODAE), to develop and evaluate a data-assimilative hybrid coordinate ocean model.`,
  },
  paragraph1: {
    value: `HYCOM GOFS 3.1 was replaced by HYCOM ESPC-D-V02 on 5 September 2024. Instead of extending our existing HYCOM data set with HYCOM ESPC-D-V02, we have decided to offer ESPC-D-V02 as a new data set. Because ESPC-D-V02 includes diurnal tidal variation, it's not compatible with GOFS 3.1, which did not. Users who want to combine data from ESPC-D-V02 with earlier HYCOM data should create combined HYCOM/DTU10 Tide files and then extend these with ESPC-D-V02 to create a consistent record.`,
  },
  table: {
    value: {
      header: ["General", "Model"],
      hiddenHeaders: ["Model"],
      rows: [
        {
          General: "Title",
          Model: "ESPC-D-V02: Global 1/12° Analysis",
        },
        {
          General: "Geographical Coverage",
          Model: "Global",
        },
        {
          General: "Category",
          Model: "Ocean Parameters",
        },
        {
          General: "Source Name",
          Model:
            "ESPC-D-V02: Global 1/12° Analysis output on the GLBy0.08 grid",
        },
        {
          General: "Publisher",
          Model: "Fleet Numerical Meteorology and Oceanography Center (FNMOC)",
        },
        {
          General: "Cost (ex. VAT)",
          Model: "Free",
        },
        {
          General: "Typical Applications",
          Model: "Hydrodynamic, Offshore and Marine projects",
        },
        {
          General: "References",
          Model: `HYCOM home: ***https://www.hycom.org/*** ESPC-D-V02: Global 1/12° Analysis (Dataset): ***https://www.hycom.org/dataserver/espc-d-v02/global-analysis***`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ["Coverage", "Model"],
      hiddenHeaders: ["Model"],
      rows: [
        {
          Coverage: "Geographical Range",
          Model: `Global:
                  Longitude: 180°W -> 180°E
                  Latitude: 80°S -> 90°N`,
        },
        {
          Coverage: "Geographical Resolution",
          Model: `GLBy0.08:
                  0.08 deg. Long x 0.04 deg. Lat`,
        },
        {
          Coverage: "Vertical Reference",
          Model: "Sea surface",
        },
        {
          Coverage: "Vertical Range",
          Model: "Sea surface to Sea bed",
        },
        {
          Coverage: "Vertical Resolution",
          Model: "41 layers",
        },
        {
          Coverage: "Temporal Reference",
          Model: "UTC",
        },
        {
          Coverage: "Temporal Range",
          Model: `Data Link coverage:
                  GLBy0.08: 93: 10/08-2024 -> Present`,
        },
        {
          Coverage: "Temporal Resolution",
          Model: "3-hourly, except Sea Surface Height (1-hourly)",
        },
      ],
    },
  },
  table2: {
    value: {
      header: ["Variables", "Model"],
      hiddenHeaders: ["Model"],
      rows: [
        {
          Variables: "Name (Unit)",
          Model: `Sea Surface Height [m]
                  Water Temperature [deg C]
                  Salinity [psu]
                  U-velocity component (East dir.) [m/s]
                  V-velocity component (North dir.) [m/s]`,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ["Credits", "Model"],
      hiddenHeaders: ["Model"],
      rows: [
        {
          Credits: "Data product Authors and Originators",
          Model: `DOC/NOAA/NWS/NCEP > National Centers for Environmental Prediction, National Weather Service, NOAA, U.S. Department of Commerce`,
        },
        {
          Credits: "Data product Publisher",
          Model: `NOAA National Centers for Environmental Information. DOC/NOAA/NESDIS/NCDC > National Climatic Data Center, NESDIS, NOAA, U.S. Department of Commerce`,
        },
      ],
    },
  },
};
